import { useCallback, useContext, useMemo, useState } from "react";
import { IconPlus } from "@tabler/icons-react";
import { useSetActionButtons } from "../services/ActionButtonsContext";
import { useGetAllTickets } from "../api/newTickets";
import { getCurrentWorkspace } from "../services/userConfig";
import { AuthContext } from "../services/context";

import { openCreateNewTicketModal } from "../components/NewTickets/CreateNewTicketModal";
import { NewTicketsDatatable } from "../components/NewTickets/NewTicketsDatatable";

export default function NewTickets() {
  const { user } = useContext(AuthContext);
  const currentWorkspace = getCurrentWorkspace(user);
  const currentEventId = currentWorkspace.eventId;
  const [page, setPage] = useState(1);

  const { data, isLoading } = useGetAllTickets({
    eventId: currentEventId,
    page,
  });

  const handleOpenNewTicketModal = useCallback(() => {
    openCreateNewTicketModal({ eventId: currentEventId, action: "create" });
  }, [currentEventId]);

  const actions = useMemo(
    () => [
      {
        label: "Create",
        onClick: handleOpenNewTicketModal,
        icon: <IconPlus />,
      },
    ],
    [currentEventId]
  );

  useSetActionButtons(actions);
  return (
    <NewTicketsDatatable
      data={data}
      pagination={data?.pagination}
      fetching={isLoading}
      setPage={setPage}
      page={page}
    />
  );
}
